export const sections = [
    {
      title: "Collaboration & Communication",
      items: [
        { key: "teamwork", label: "Teamwork" },
        { key: "communication", label: "Communication" },
        { key: "feedback", label: "Giving and Recieving Feedback" },
      ],
    },
    {
      title: "Execution & Problem-Solving",
      items: [
        { key: "decision_making", label: "Decision Making" },
        { key: "process_thinking", label: "Process Thinking" },
        { key: "work_relationships", label: "Work Relationships" },
      ],
    },
    {
      title: "Growth & Strategic Thinking",
      items: [
        { key: "time_management", label: "Time and Task Management" },
        { key: "analytical_thinking", label: "Analytical Thinking" },
        { key: "quality_and_technical_skills", label: "Quality and Technical Skills" },
        { key: "mentoring", label: "Mentoring" },
        { key: "business_acumen_and_strategy", label: "Business Acumen & Strategy" },
      ],
    },
  ];
